// src/app/mock/user.fixtures.ts
import { UserModel } from '@/model/user.model';

export const USER_FIXTURES: UserModel[] = [
    {
        id: 1,
        no: 1,
        userId: 'USR001',
        empId: 'EMP001',
        name: 'Alice Johnson',
        email: 'alice.johnson@example.com',
        gender: 'Female',
        phone: '012 111 001',
        role: { id: 2, name: 'Standard - Master HQ Level 1', code: 'STD_L1' },
        branch: { id: 1, name: 'Phnom Penh', code: '001' },
        branchCluster: { id: 2, name: 'Other Branch', code: '002' },
        department: { id: 3, name: 'Marketing', code: '003' },
        remark: 'Standard - Master HQ Level 1',
        created: '2024-01-10T08:00:00Z',
        updated: '2024-05-01T10:00:00Z',
        status: 1,
        action: 'view',
        loginInfo: {
            accessDateFrom: new Date('2026-12-30'),
            accessDateTo: new Date('2027-12-30'),
            accessTimeFrom: '08:00',
            accessTimeTo: '17:00',
            maxFailedAttempts: 3,
            passwordExpired: '',
            authorizedBy: { id: 1, userId: 'USER001', name: 'Alic' },
            authorizedDate: new Date('2026-01-15')
        }
    },
    {
        id: 2,
        no: 2,
        userId: 'USR002',
        empId: 'EMP002',
        name: 'Bob Smith',
        email: 'bob.smith@example.com',
        gender: 'Male',
        phone: '012 111 002',
        role: { id: 1, name: 'Admin', code: 'ADMIN' },
        branch: { id: 5, name: 'Digital Branch', code: '005' },
        branchCluster: { id: 2, name: 'Other Branch', code: '002' },
        department: { id: 4, name: 'Development', code: '004' },
        remark: 'Development',
        created: '2024-02-15T08:00:00Z',
        updated: '2024-06-01T10:00:00Z',
        status: 2,
        action: 'view',
        loginInfo: {
            accessDateFrom: new Date('2026-12-30'),
            accessDateTo: new Date('2027-12-30'),
            accessTimeFrom: '08:00',
            accessTimeTo: '17:00',
            maxFailedAttempts: 3,
            passwordExpired: '',
            authorizedBy: { id: 1, userId: 'USER001', name: 'Alic' },
            authorizedDate: new Date('2026-01-15')
        }
    },
    {
        id: 3,
        no: 3,
        userId: 'USR003',
        empId: 'EMP003',
        name: 'Chenda Sok',
        email: 'chenda.sok@example.com',
        gender: 'Female',
        phone: '012 111 003',
        role: { id: 4, name: 'Viewer', code: 'VIEWER' },
        branch: { id: 2, name: 'Siem Reap', code: '002' },
        branchCluster: { id: 2, name: 'Other Branch', code: '002' },
        department: { id: 2, name: 'Accounting', code: '002' },
        remark: 'Accounting',
        created: '2024-03-01T08:00:00Z',
        updated: '2024-06-02T09:00:00Z',
        status: 3,
        action: 'view',
        loginInfo: {
            accessDateFrom: new Date('2026-12-30'),
            accessDateTo: new Date('2027-12-30'),
            accessTimeFrom: '08:00',
            accessTimeTo: '17:00',
            maxFailedAttempts: 3,
            passwordExpired: '',
            authorizedBy: { id: 1, userId: 'USER001', name: 'Alic' },
            authorizedDate: new Date('2026-01-15')
        }
    },
    {
        id: 4,
        no: 4,
        userId: 'USR004',
        empId: 'EMP004',
        name: 'Dara Chan',
        email: 'dara.chan@example.com',
        gender: 'Male',
        phone: '012 111 004',
        role: { id: 1, name: 'Admin', code: 'ADMIN' },
        branch: { id: 4, name: 'Kampot', code: '004' },
        branchCluster: { id: 3, name: 'Battambang', code: '003' },
        department: { id: 1, name: 'Sale', code: '001' },
        remark: 'Battambang Provice',
        created: '2024-04-10T08:00:00Z',
        updated: '2024-06-03T11:00:00Z',
        status: 4,
        action: 'view',
        loginInfo: {
            accessDateFrom: new Date('2026-12-30'),
            accessDateTo: new Date('2027-12-30'),
            accessTimeFrom: '08:00',
            accessTimeTo: '17:00',
            maxFailedAttempts: 3,
            passwordExpired: '',
            authorizedBy: { id: 1, userId: 'USER001', name: 'Alic' },
            authorizedDate: new Date('2026-01-15')
        }
    }
];

export const ROLE_DROPDOWN_FIXTURES = [
    { id: 1, name: 'Admin', code: 'ADMIN' },
    { id: 2, name: 'Standard - Master HQ Level 1', code: 'STD_L1' },
    { id: 3, name: 'Standard - Master HQ Level 2', code: 'STD_L2' },
    { id: 4, name: 'Viewer', code: 'VIEWER' }
];

export const BRANCH_DROPDOWN_FIXTURES = [
    { id: 1, name: 'Phnom Penh', code: '001' },
    { id: 2, name: 'Siem Reap', code: '002' },
    { id: 3, name: 'Battambang', code: '003' },
    { id: 4, name: 'Kampot', code: '004' },
    { id: 5, name: 'Digital Branch', code: '005' }
];
export const BRANCH_CLUSTER_DROPDOWN_FIXTURES = [
    { id: 1, name: 'Digital Branch', code: '001' },
    { id: 2, name: 'Other Branch', code: '002' },
    { id: 3, name: 'Battambang', code: '003' }
];
export const DEPARTMENT_DROPDOWN_FIXTURES = [
    { id: 1, name: 'Sale', code: '001' },
    { id: 2, name: 'Accounting', code: '002' },
    { id: 3, name: 'Marketing', code: '003' },
    { id: 4, name: 'Development', code: '004' }
];
